import * as yup from "yup";
import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { ViewProps } from "../props";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface LookupGroupFormProps<T> {
    data?: T | undefined;
    show: boolean;
    lookupCategoryLookupValues?: DropdownOption[] | undefined;
    onHide: () => void;
    onSave: (values: any) => DrawerFormSaveResult;
    isLoading: boolean;
}

const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    description: yup.string().optional(),
});

export function LookupGroupForm<T extends ViewProps.GroupTypeDto>(
    props: LookupGroupFormProps<T>
) {
    let title: string = "Edit Lookup Group";
    if (
        StringHelper.whenNullOrEmpty(props.data?.id, Constants.emptyGuid) ===
        Constants.emptyGuid
    ) {
        title = "New Lookup Group";
    }

    const onSubmit = (data: any) => {
        return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
    };

    const isNew = !props.data?.id || props.data?.id === Constants.emptyGuid;

    return (
        <Drawer.Form
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={() => props.onHide()}
            title={title}
            initialValues={props.data ?? {}}
            validationSchema={validationSchema}
            on_Submit={onSubmit}
            enableReinitialize
        >
            <Form.Text
                name="name"
                placeholder="Enter text"
                label="Name"
                isLoading={props.isLoading}
            />
            <Form.TextArea
                name="description"
                rows={3}
                label="Description"
                isLoading={props.isLoading}
            />
            <Form.Dropdown
                name={"categoryId"}
                label={"Category"}
                isLoading={props.isLoading}
                blankOption={{ key: Constants.emptyGuid, display: '--Select Category--', value: Constants.emptyGuid }}
                options={props?.lookupCategoryLookupValues}
            />
        </Drawer.Form>
    );
}
